var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,5h-3V2l-1-1H6l-1,1v3H2l-1,1v12l1,1h3v3l1,1h12l1-1v-3h3l1-1V6l-1-1ZM7,3h10v2H7V3Zm10,18H7v-6h10v6Zm4-4h-2v-3l-1-1H6l-1,1v3H3V7H21v10ZM7,11h-2v-2h2v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/1768397567/media/icon-print.76e8612d4f68345ec2e0d5c2824cbb95.svg";
export { ForwardRef as ReactComponent };